var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedInLogo = function SvgLinkedInLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LinkedInLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    d: "M23.128 0H2.638C1.657 0 .863.775.863 1.733v20.574c0 .958.794 1.737 1.775 1.737h20.49c.981 0 1.78-.78 1.78-1.733V1.733c0-.958-.799-1.733-1.78-1.733M7.997 20.49h-3.57V9.011h3.57zM6.212 7.447a2.067 2.067 0 1 1 0-4.133 2.066 2.066 0 0 1 0 4.133m15.14 13.041h-3.564V14.91c0-1.329-.023-3.043-1.855-3.043-1.855 0-2.136 1.451-2.136 2.95v5.672h-3.56V9.012h3.419v1.569h.047c.474-.902 1.639-1.856 3.371-1.856 3.612 0 4.279 2.377 4.279 5.467z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "LinkedInLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.863 0h24.044v24.044H.863z"
  })))));
};
export default SvgLinkedInLogo;